import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, T4coreModule, UIService } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { CreateCampaignDialog } from './dialogs/createCampaignDialog/createCampaignDialog';
import { GenerateVouchersResultDialog } from './dialogs/generateVouchersResultDialog/generateVouchersResultDialog';
import { CampaignComponent } from './views/campaign/campaign.component';
import { FindCampaignDialog } from './dialogs/findCampaignDialog/findCampaignDialog';
import { CampaignInfoDialog } from './dialogs/campaignInfo/campaignInfoDialog';
import { HomeComponent } from './views/home/home.component';
import { CreateVouchersResultDialog } from './dialogs/createVouchers/createVouchersDialog';
import { CampaignListComponent } from './views/campaignlist/campaignlist.component';
import { PartnerCampaignComponent } from './views/partnerCampaign/partnerCampaign';
import { CreatePartnerCampaignDialog } from './dialogs/createPartnerCampaignDialog/createPartnerCampaignDialog';
import { PartnerDashboard } from './views/partnerDashboard/partnerDashboard';
import { CampaignSMSComponent } from './views/campaignSMS/campaignSMS';
import { CampaingOverviewDBWidget } from './widgets/campaignOverview/campaignOverview';
import { CreateNotificationSettingComponent } from './dialogs/create-notification-setting/create-notification-setting.component';

@NgModule({
  declarations: [
    HomeComponent,
    CampaignListComponent,
    CampaignComponent,
    PartnerCampaignComponent,
    PartnerDashboard,
    GenerateVouchersResultDialog,
    FindCampaignDialog,
    CreateCampaignDialog,
    CreatePartnerCampaignDialog,
    CampaignInfoDialog,
    CreateVouchersResultDialog,
    CampaingOverviewDBWidget,
    CampaignSMSComponent,
    CreateNotificationSettingComponent
    ],
    imports: [
      T4CommonModule,
      T4coreModule,
        RouterModule.forChild([
            {
                path: 'Campaigns',
                canActivate: [AuthGuard],
                data: { index: 40, title: "Campaigns", toolTip: "Manage your campaigns", roles: ['LocationManager', 'Admin', 'GroupManager', 'BusinessManager'], requireCampaignEnabled: true, icon: 'campaign' },
                children: [
                  { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
                  {
                    path: "Dashboard",
                    canActivate: [AuthGuard],
                    component: HomeComponent,
                    data: { title: "Dashboard", toolTip: "Dashboard", roles: ['LocationManager', 'GroupManager', 'Admin', 'Sales'], icon: 'bar_chart' }
                  },
                  {
                        path: "Dashboard",
                        canActivate: [AuthGuard],
                        component: HomeComponent,
                    data: { title: "Dashboard", hidden: true, toolTip: "Dashboard", roles: ['LocationManager', 'GroupManager', 'Admin'], icon: 'bar_chart' }
                  },
                  {
                    path: "Campaignlist",
                    canActivate: [AuthGuard],
                    component: CampaignListComponent,
                    data: { title: "Campaigns", toolTip: "Campaigns", roles: ['LocationManager', 'GroupManager', 'Admin'], icon: 'bar_chart' }
                  },
                  {
                    path: "PartnerDashboard",
                    canActivate: [AuthGuard],
                    component: PartnerDashboard,
                    data: { title: "Dashboard offers", toolTip: "Dashboard offers", roles: ['LocationManager', 'GroupManager', 'Admin', 'BusinessManager'], requireCampaignEnabled: true, icon: 'bar_chart' }
                  },
                  {
                    path: "PartnerCamapigns",
                    canActivate: [AuthGuard],
                    component: PartnerCampaignComponent,
                    data: { title: "Offers", toolTip: "Offers", roles: ['LocationManager', 'GroupManager', 'Admin', 'BusinessManager'], requireCampaignEnabled: true, icon: 'bar_chart' }
                  },
                  //{
                  //  path: "PartnerCamapignsSMS",
                  //  canActivate: [AuthGuard],
                  //  component: CampaignSMSComponent,
                  //  data: { title: "SMS Service", toolTip: "SMS Service", roles: ['LocationManager', 'GroupManager', 'Admin'], icon: 'bar_chart' }
                  //},
                  {
                    path: "Campaign/:CampaignID",
                    canActivate: [AuthGuard],
                    component: CampaignComponent,
                    data: { hidden: true, title: "Campaign", toolTip: "Campaign", roles: ['LocationManager', 'GroupManager', 'Admin'], icon: 'bar_chart' }
                  },
                  {
                    path: "NotificationSettings/create",
                    canActivate: [AuthGuard],
                    component: CreateNotificationSettingComponent,
                    data: { hidden: true, roles: ['Admin', 'LocationManager', 'GroupManager'] }
                  },
                  {
                    path: "NotificationSettings/:id",
                    canActivate: [AuthGuard],
                    component: CreateNotificationSettingComponent,
                    data: { hidden: true, roles: ['Admin', 'LocationManager', 'GroupManager'] }
                  },
                ]
            },
        ])
    ],
    providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }]
})
export class CampaignsModule { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.Campaigns.GenerateVouchersResultDialog", dialog: GenerateVouchersResultDialog },
        { key: "T4.Campaigns.CampaignInfoDialog", dialog: CampaignInfoDialog },
        { key: "T4.Campaigns.CreateCampaignDialog", dialog: CreateCampaignDialog },
        { key: "T4.Campaigns.CreateVouchersDialog", dialog: CreateVouchersResultDialog },
        { key: "T4.Campaings.CreatePartnerCampaingDialog", dialog: CreatePartnerCampaignDialog }
      ]
    });
  };
}
// Module initialization
